import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
function Invoice() {
  const print = () => {
    window.print();
  };
  return (
    <div>
      <ol className="breadcrumb hidden-print pull-right">
        <li className="breadcrumb-item">
          <Link to="./home">Home</Link>
        </li>
        <li className="breadcrumb-item">
          <Link to="">Packages and billing</Link>
        </li>
        <li className="breadcrumb-item active">Invoice</li>
      </ol>
      <h1 className="page-header hidden-print">Invoice</h1>
      <div className="invoice">
        <div className="invoice-company text-inverse f-w-600">
          <span className="pull-right hidden-print">
            <button className="btn btn-sm btn-white m-b-10 p-l-5 m-r-5">
              <i className="fa fa-file-pdf t-plus-1 text-danger fa-fw fa-lg"></i>{" "}
              Export as PDF
            </button>
            {/*<button
              onClick={print}
              className="btn btn-sm btn-white m-b-10 p-l-5"
            >
              <i className="fa fa-print t-plus-1 fa-fw fa-lg"></i> Print
           </button>*/}
          </span>
          <a href="/" class="align-items-end d-flex">
            <img src="../assets/img/logo/STT-Logo.png" alt="" height="30px" />
            <h4 class="mb-0 ml-1">STT</h4>
          </a>
        </div>
        <div className="invoice-header">
          <div>
            <div className="invoice-from">
              <h4 className="mb-0">STT-Scan to Tell</h4>
              <p>Next Generation QR Codes</p>
              <small>from</small>
              <address className="m-t-5 m-b-5">
                <strong className="text-inverse">4MB Technical services</strong>
                <br />
                Stentenberg str 31
                <br />
                151702 Bergneustadt
                <br />
                Germany
              </address>
            </div>
            <div className="invoice-to">
              <small>to</small>
              <address className="m-t-5 m-b-5">
                <strong className="text-inverse">xyz@gmail.com</strong>
                <br />
                User Name
                <br />
                User company name
                <br />
                User company Address
              </address>
            </div>
          </div>

          <div className="invoice-date">
            <div className="invoice-detail">
              INVOICE <div>12-2016/SRS-01</div>
            </div>
            <div className="invoice-detail">INVOICE MONTH August 2022</div>
            <div className="invoice-detail">DATE 29/12/16</div>
          </div>
        </div>
        <p>
          <strong>Subscribed package : </strong>Starter individual
        </p>
        <div className="invoice-content">
          <div className="table-responsive">
            <table className="table table-invoice">
              <thead>
                <tr>
                  <th width="10%">Quantity</th>
                  <th>Description</th>
                  <th width="10%" className="text-center">
                    Unit price
                  </th>
                  <th width="20%" className="text-right">
                    TOTAL
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>
                    <span className="text-inverse">
                      STT-Scan to Tell monthly subscription
                    </span>
                  </td>
                  <td className="text-center">9.99 €</td>
                  <td className="text-right">9.99 €</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="invoice-price">
            <div className="invoice-price-left">
              <div className="invoice-price-row">
                <div className="sub-price">
                  <small>SUBTOTAL</small>
                  <span className="text-inverse">9.99 €</span>
                </div>
                <div className="sub-price">
                  <i className="fa fa-plus text-muted"></i>
                </div>
                <div className="sub-price">
                  <small>VAT (20%)</small>
                  <span className="text-inverse">1.99 €</span>
                </div>
              </div>
            </div>
            <div className="invoice-price-right">
              <small>TOTAL</small> <span className="f-w-600">11.99 €</span>
            </div>
          </div>
        </div>
        <div className="invoice-note">
          * This is computer generated invoice and valid without signature
        </div>
        <div className="invoice-footer">
          <p className="text-center m-b-5 f-w-600">STT-Scan to Tell</p>
          <p className="text-center">
            <span className="m-r-10">
              <i className="fa fa-fw fa-lg fa-location"></i> 4MB Technical
              services, Stentenberg str 31, 151702 Bergneustadt, Germany
            </span>
          </p>
          <h6 className="text-center m-b-5 f-w-800">
            THANK YOU FOR YOUR BUSINESS
          </h6>
        </div>
      </div>
    </div>
  );
}

export default Invoice;
